module.exports = "/_next/static/images/top_etfs_mobile-95f395d28cb2b74db703aa334ef206f8.jpeg";